export const DetailDialogTestIds = {
  CLOSE_DIALOG_BUTTON: 'close-dialog-button',
};
